var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmailLastV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 40,
    viewBox: "0 0 45 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0001 35.9781C45.0006 36.5065 44.8969 37.03 44.6949 37.5184C44.493 38.0068 44.1967 38.4506 43.8231 38.8245C43.4495 39.1984 43.0058 39.495 42.5174 39.6973C42.0291 39.8997 41.5056 40.0039 40.977 40.0039H4.02697C3.49833 40.0039 2.97489 39.8997 2.48654 39.6973C1.99818 39.495 1.5545 39.1984 1.18088 38.8245C0.80725 38.4506 0.510989 38.0068 0.309037 37.5184C0.107085 37.03 0.0034027 36.5065 0.00390809 35.9781V14.738C0.00478331 14.5073 0.0253606 14.2771 0.0654362 14.0498L21.3001 27.2883L21.3808 27.3306L21.4654 27.3728C21.6117 27.4509 21.7666 27.5115 21.927 27.5536H21.977C22.1485 27.5943 22.3238 27.6161 22.5001 27.6189C22.6777 27.6183 22.8546 27.5964 23.027 27.5536H23.0731C23.2345 27.5109 23.3906 27.4502 23.5385 27.3728L23.6231 27.3306L23.7001 27.2883L44.9347 14.0498C44.9781 14.2767 45 14.5071 45.0001 14.738V35.9781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5001 0L44.7232 13.8537H0.273193L22.5001 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 40,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailLastV);
export default __webpack_public_path__ + "static/media/emailLastV.98f9afb1079dd9b619d80b569e589e22.svg";
export { ForwardRef as ReactComponent };